import React from 'react';
import {
  ReferenceManyField,
  Labeled,
  ReferenceField,
  FunctionField,
  TextField,
  Datagrid,
} from 'react-admin';

import '../styles.css';

const RestrictionData = (props) => {
  const { data, ids, loadedOnce } = props;
  if (!loadedOnce) {
    return null;
  }
  return data && ids.length > 0 ? (
    <Datagrid {...props}>
      <TextField label="Folio Restriction Id" source="accountRestrictionId" />
      <TextField label="Description" source="type.description" />
      <TextField label="Reason Code" source="reason.code" />
      <TextField label="Reason Name" source="reason.name" />
    </Datagrid>
  ) : <span className="normalField">No Restrictions</span>;
};

const Restrictions = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return record && record.accountNumber && (
    <ReferenceManyField basePath="/accounts" reference="accountRestrictions" target="accountNumber" record={record} sortable={false}>
      <RestrictionData />
    </ReferenceManyField>
  );
};

const PositionData = (props) => {
  const { data, ids, loadedOnce } = props;
  if (!loadedOnce) {
    return null;
  }
  return data && ids.length > 0 ? (
    <Datagrid {...props}>
      <TextField label="Company Name" source="security.companyName" />
      <TextField label="Ticker" source="security.ticker'" />
      <TextField label="Share Quantity" source="shareQuantity" />
      <TextField label="Current Weight" source="currentWeight" />
      <TextField label="Short Term Cost" source="shortTermCostBasis" />
      <TextField label="Long Term Cost" source="longTermCostBasis" />
      <TextField label="Instrument Type" source="security.instrumentType" />
      <TextField label="Settlement Period" source="security.settlementPeriod" />
    </Datagrid>
  ) : <span className="normalField">No Positions</span>;
};

const Positions = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return record && record.accountNumber && (
    <ReferenceManyField basePath="/accounts" reference="accountPositions" target="accountNumber" record={record} sortable={false}>
      <PositionData />
    </ReferenceManyField>
  );
};

const TransactionData = (props) => {
  const { data, ids, loadedOnce } = props;
  if (!loadedOnce) {
    return null;
  }
  return data && ids.length > 0 ? (
    <Datagrid {...props}>
      <TextField label="Date" source="date" />
      <TextField label="Description" source="transactionDesc" />
      <TextField label="Ticker" source="ticker" />
      <TextField label="Symbol Name" source="symbolName" />
      <TextField label="Quantity" source="quantity" />
      <TextField label="Price" source="price" />
    </Datagrid>
  ) : <span className="normalField">No Transactions</span>;
};

const Transactions = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return record && record.accountNumber && (
    <ReferenceManyField basePath="/accounts" reference="accountTransactions" target="accountNumber" record={record} sortable={false}>
      <TransactionData />
    </ReferenceManyField>
  );
};

const EndMarketValue = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return record && record.accountNumber && (
    <ReferenceField basePath="/accounts" reference="accountPerformanceSummary" source="accountNumber" record={record} linkType={false}>
      <FunctionField
        render={innerRecord => (innerRecord.endMarketValue ?
          <span className="normalField">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(innerRecord.endMarketValue)}</span> :
          <span className="normalField">N/A</span>)
        }
      />
    </ReferenceField>
  );
};

const CashBalance = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return record && record.accountNumber && (
    <ReferenceField basePath="/accounts" reference="accountCashBalance" source="accountNumber" record={record} linkType={false}>
      <FunctionField
        render={innerRecord => (innerRecord.balanceAvailableForT1Trades ?
          <span className="normalField">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(innerRecord.balanceAvailableForT1Trades)}</span> :
          <span className="normalField">N/A</span>)
        }
      />
    </ReferenceField>
  );
};

export default ({ record }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td>
          <Labeled label="End Market Value">
            <ReferenceManyField basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <EndMarketValue />
            </ReferenceManyField>
          </Labeled>
        </td>
        <td>
          <Labeled label="Cash Balance">
            <ReferenceManyField basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <CashBalance />
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
      <tr>
        <td colSpan={2}>
          <Labeled label="Restrictions">
            <ReferenceManyField basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <Restrictions />
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Positions">
            <ReferenceManyField basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <Positions />
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
      <tr colSpan={2}>
        <td>
          <Labeled label="Transactions">
            <ReferenceManyField basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <Transactions />
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
    </tbody>
  </table>
);




// WEBPACK FOOTER //
// ./src/components/User/children/FolioData_Show.jsx